import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "mx-auto max-w-2xl lg:max-w-none" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("h2", { class: "mt-2" }, "Examples", -1 /* HOISTED */)
const _hoisted_3 = { key: 1 }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_ExamplesCollection = _resolveComponent("ExamplesCollection")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _hoisted_2,
    (_ctx.exampleNames.length)
      ? (_openBlock(), _createBlock(_component_ExamplesCollection, {
          key: _ctx.context + '/' + _ctx.type,
          exampleNames: _ctx.exampleNames,
          exampleDatas: _ctx.exampleDatas
        }, null, 8 /* PROPS */, ["exampleNames", "exampleDatas"]))
      : (_openBlock(), _createElementBlock("div", _hoisted_3, "no examples"))
  ]))
}